import { render, staticRenderFns } from "./PartnerDetay.vue?vue&type=template&id=ed138e76&scoped=true&"
import script from "./PartnerDetay.vue?vue&type=script&lang=js&"
export * from "./PartnerDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed138e76",
  null
  
)

export default component.exports